module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-22.a821d431.jpg";